import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { transformSDKFloatToRESTFloat } from '@wix/sdk-runtime/transformations/float';
import { transformRESTFloatToSDKFloat } from '@wix/sdk-runtime/transformations/float';
import { transformSDKTimestampToRESTTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformSDKFieldMaskToRESTFieldMask } from '@wix/sdk-runtime/transformations/field-mask';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';
import {
  _Array,
  _Boolean,
  _Date,
  _Number,
  _Object,
} from './data-v2-data-collection-collections.types';

function resolveComWixpressCloudDataApiCollectionserviceDataCollectionServiceUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'api._api_base_domain_': [
      {
        srcPath: '/cloud-data',
        destPath: '',
      },
    ],
    'code._base_domain_': [
      {
        srcPath: '/_api/cloud-data/v1/data-settings',
        destPath: '/v1/data-settings',
      },
      {
        srcPath: '/_api/cloud-data/v1/schemas',
        destPath: '/v1/schemas',
      },
      {
        srcPath: '/_api/cloud-data/v1/connector',
        destPath: '/v1/connector',
      },
      {
        srcPath: '/_api/data/v1/data-settings',
        destPath: '/v1/data-settings',
      },
      {
        srcPath: '/_api/data/v1/schemas',
        destPath: '/v1/schemas',
      },
      {
        srcPath: '/_api/data/v1/connector',
        destPath: '/v1/connector',
      },
      {
        srcPath: '/_api/cloud-data/v1/wix-data',
        destPath: '/v1/wix-data',
      },
    ],
    'cloud-data.wix-code.com': [
      {
        srcPath: '',
        destPath: '',
      },
    ],
    _: [
      {
        srcPath: '/_api/cloud-data',
        destPath: '',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/_api/cloud-data',
        destPath: '',
      },
      {
        srcPath: '/_api/data',
        destPath: '',
      },
      {
        srcPath: '/_api/cloud-data',
        destPath: '',
      },
    ],
    'dev._base_domain_': [
      {
        srcPath: '/_api/cloud-data',
        destPath: '',
      },
    ],
    'bo._base_domain_': [
      {
        srcPath: '/_api/cloud-data/v1',
        destPath: '/v1',
      },
      {
        srcPath: '/_api/cloud-data/v2',
        destPath: '/v2',
      },
    ],
    'wixbo.ai': [
      {
        srcPath: '/_api/cloud-data/v1',
        destPath: '/v1',
      },
      {
        srcPath: '/_api/cloud-data/v2',
        destPath: '/v2',
      },
    ],
    'wix-bo.com': [
      {
        srcPath: '/_api/cloud-data/v1',
        destPath: '/v1',
      },
      {
        srcPath: '/_api/cloud-data/v2',
        destPath: '/v2',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/_api/cloud-data',
        destPath: '',
      },
      {
        srcPath: '/_api/data',
        destPath: '',
      },
      {
        srcPath: '/_api/cloud-data',
        destPath: '',
      },
    ],
    'editor._base_domain_': [
      {
        srcPath: '/_api/cloud-data/v1/schemas',
        destPath: '/v1/schemas',
      },
      {
        srcPath: '/_api/cloud-data/dbs/tasks',
        destPath: '/dbs/tasks',
      },
      {
        srcPath: '/_api/data/v1/schemas',
        destPath: '/v1/schemas',
      },
      {
        srcPath: '/_api/data/dbs/tasks',
        destPath: '/dbs/tasks',
      },
      {
        srcPath: '/_api/cloud-data/v1/wix-data',
        destPath: '/v1/wix-data',
      },
      {
        srcPath: '/_api/cloud-data/v1/data-settings',
        destPath: '/v1/data-settings',
      },
      {
        srcPath: '/_api/data/v2/indexes',
        destPath: '/v2/indexes',
      },
      {
        srcPath: '/_api/cloud-data/v1/external-database-connections',
        destPath: '/v1/external-database-connections',
      },
      {
        srcPath: '/_api/data/v1/data-collection-sharing',
        destPath: '/v1/data-collection-sharing',
      },
      {
        srcPath: '/_api/cloud-data/v2/collections',
        destPath: '/v2/collections',
      },
      {
        srcPath: '/_api/cloud-data/v2/bulk',
        destPath: '/v2/bulk',
      },
      {
        srcPath: '/_api/cloud-data/v2/items',
        destPath: '/v2/items',
      },
      {
        srcPath: '/_api/cloud-data/v2/dbs/tasks',
        destPath: '/v2/dbs/tasks',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/_api/cloud-data/v1/schemas',
        destPath: '/v1/schemas',
      },
      {
        srcPath: '/_api/cloud-data/dbs/tasks',
        destPath: '/dbs/tasks',
      },
      {
        srcPath: '/_api/data/v1/schemas',
        destPath: '/v1/schemas',
      },
      {
        srcPath: '/_api/data/dbs/tasks',
        destPath: '/dbs/tasks',
      },
      {
        srcPath: '/_api/cloud-data/v1/wix-data',
        destPath: '/v1/wix-data',
      },
      {
        srcPath: '/_api/cloud-data/v1/data-settings',
        destPath: '/v1/data-settings',
      },
      {
        srcPath: '/_api/data/v2/indexes',
        destPath: '/v2/indexes',
      },
      {
        srcPath: '/_api/cloud-data/v1/external-database-connections',
        destPath: '/v1/external-database-connections',
      },
      {
        srcPath: '/_api/data/v1/data-collection-sharing',
        destPath: '/v1/data-collection-sharing',
      },
      {
        srcPath: '/_api/cloud-data/v2/collections',
        destPath: '/v2/collections',
      },
      {
        srcPath: '/_api/cloud-data/v2/bulk',
        destPath: '/v2/bulk',
      },
      {
        srcPath: '/_api/cloud-data/v2/items',
        destPath: '/v2/items',
      },
      {
        srcPath: '/_api/cloud-data/v2/dbs/tasks',
        destPath: '/v2/dbs/tasks',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/_api/cloud-data/v1/schemas',
        destPath: '/v1/schemas',
      },
      {
        srcPath: '/_api/cloud-data/dbs/tasks',
        destPath: '/dbs/tasks',
      },
      {
        srcPath: '/_api/data/v1/schemas',
        destPath: '/v1/schemas',
      },
      {
        srcPath: '/_api/data/dbs/tasks',
        destPath: '/dbs/tasks',
      },
      {
        srcPath: '/_api/cloud-data/v1/wix-data',
        destPath: '/v1/wix-data',
      },
      {
        srcPath: '/_api/cloud-data/v1/data-settings',
        destPath: '/v1/data-settings',
      },
      {
        srcPath: '/_api/data/v2/indexes',
        destPath: '/v2/indexes',
      },
      {
        srcPath: '/_api/cloud-data/v1/external-database-connections',
        destPath: '/v1/external-database-connections',
      },
      {
        srcPath: '/_api/data/v1/data-collection-sharing',
        destPath: '/v1/data-collection-sharing',
      },
      {
        srcPath: '/_api/cloud-data/v2/collections',
        destPath: '/v2/collections',
      },
      {
        srcPath: '/_api/cloud-data/v2/bulk',
        destPath: '/v2/bulk',
      },
      {
        srcPath: '/_api/cloud-data/v2/items',
        destPath: '/v2/items',
      },
      {
        srcPath: '/_api/cloud-data/v2/dbs/tasks',
        destPath: '/v2/dbs/tasks',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/wix-data/v1/collections',
        destPath: '/v1/wix-data/collections',
      },
      {
        srcPath: '/wix-data/v1/external-database-connections',
        destPath: '/v1/external-database-connections',
      },
      {
        srcPath: '/wix-data/v2/indexes',
        destPath: '/v2/indexes',
      },
      {
        srcPath: '/wix-data/v1/items',
        destPath: '/v1/items',
      },
      {
        srcPath: '/wix-data/v1/bulk',
        destPath: '/v1/bulk',
      },
      {
        srcPath: '/wix-data/v1/external-databases',
        destPath: '/v1/external-databases',
      },
      {
        srcPath: '/wix-data/v2',
        destPath: '/v2',
      },
      {
        srcPath: '/data/v2/collections',
        destPath: '/v2/collections',
      },
      {
        srcPath: '/data/v2/items',
        destPath: '/v2/items',
      },
      {
        srcPath: '/data/v2/bulk/items',
        destPath: '/v2/bulk/items',
      },
      {
        srcPath: '/data/v2/indexes',
        destPath: '/v2/indexes',
      },
      {
        srcPath: '/data/v1/external-database-connections',
        destPath: '/v1/external-database-connections',
      },
      {
        srcPath: '/data/v1/data-collection-sharing',
        destPath: '/v1/data-collection-sharing',
      },
    ],
    'www.wixgateway.com': [
      {
        srcPath: '/wix-data/v1/items',
        destPath: '/v1/items',
      },
      {
        srcPath: '/wix-data/v1/bulk',
        destPath: '/v1/bulk',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/_api/cloud-data/v2',
        destPath: '/v2',
      },
      {
        srcPath: '/_api/cloud-data/v1/external-database-connections',
        destPath: '/v1/external-database-connections',
      },
      {
        srcPath: '/data/v1/data-collection-sharing',
        destPath: '/v1/data-collection-sharing',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_data_collections';

/**
 * Creates a new data collection.
 *
 * The request body must include an ID, details for at least 1 field, and a permissions object. If any of these are missing, the collection isn't created.
 */
export function createDataCollection(
  payload: object
): RequestOptionsFactory<any> {
  function __createDataCollection({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: 'collection.createdDate' },
          { path: 'collection.updatedDate' },
          { path: 'collection.fields.typeMetadata.date.defaultValueFixed' },
          { path: 'collection.fields.typeMetadata.date.minDateFixed' },
          { path: 'collection.fields.typeMetadata.date.maxDateFixed' },
          { path: 'collection.fields.typeMetadata.datetime.defaultValueFixed' },
          { path: 'collection.fields.typeMetadata.datetime.minDateFixed' },
          { path: 'collection.fields.typeMetadata.datetime.maxDateFixed' },
        ],
      },
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: 'collection.fields.numberRange.min' },
          { path: 'collection.fields.numberRange.max' },
          { path: 'collection.fields.typeMetadata.number.defaultValue' },
          { path: 'collection.fields.typeMetadata.number.min' },
          { path: 'collection.fields.typeMetadata.number.max' },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.data.v2.data_collection',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.cloud.data.api.collectionservice.DataCollectionService.CreateDataCollection',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressCloudDataApiCollectionserviceDataCollectionServiceUrl(
        { protoPath: '/v2/collections', data: serializedData, host }
      ),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'collection.createdDate' },
              { path: 'collection.updatedDate' },
              { path: 'collection.fields.typeMetadata.date.defaultValueFixed' },
              { path: 'collection.fields.typeMetadata.date.minDateFixed' },
              { path: 'collection.fields.typeMetadata.date.maxDateFixed' },
              {
                path: 'collection.fields.typeMetadata.datetime.defaultValueFixed',
              },
              { path: 'collection.fields.typeMetadata.datetime.minDateFixed' },
              { path: 'collection.fields.typeMetadata.datetime.maxDateFixed' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'collection.fields.numberRange.min' },
              { path: 'collection.fields.numberRange.max' },
              { path: 'collection.fields.typeMetadata.number.defaultValue' },
              { path: 'collection.fields.typeMetadata.number.min' },
              { path: 'collection.fields.typeMetadata.number.max' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __createDataCollection;
}

/** Retrieves a data collection by ID. */
export function getDataCollection(payload: object): RequestOptionsFactory<any> {
  function __getDataCollection({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.data.v2.data_collection',
      method: 'GET' as any,
      methodFqn:
        'com.wixpress.cloud.data.api.collectionservice.DataCollectionService.GetDataCollection',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressCloudDataApiCollectionserviceDataCollectionServiceUrl(
        { protoPath: '/v2/collections/{dataCollectionId}', data: payload, host }
      ),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'collection.createdDate' },
              { path: 'collection.updatedDate' },
              { path: 'collection.fields.typeMetadata.date.defaultValueFixed' },
              { path: 'collection.fields.typeMetadata.date.minDateFixed' },
              { path: 'collection.fields.typeMetadata.date.maxDateFixed' },
              {
                path: 'collection.fields.typeMetadata.datetime.defaultValueFixed',
              },
              { path: 'collection.fields.typeMetadata.datetime.minDateFixed' },
              { path: 'collection.fields.typeMetadata.datetime.maxDateFixed' },
              { path: 'referencedCollections.createdDate' },
              { path: 'referencedCollections.updatedDate' },
              {
                path: 'referencedCollections.fields.typeMetadata.date.defaultValueFixed',
              },
              {
                path: 'referencedCollections.fields.typeMetadata.date.minDateFixed',
              },
              {
                path: 'referencedCollections.fields.typeMetadata.date.maxDateFixed',
              },
              {
                path: 'referencedCollections.fields.typeMetadata.datetime.defaultValueFixed',
              },
              {
                path: 'referencedCollections.fields.typeMetadata.datetime.minDateFixed',
              },
              {
                path: 'referencedCollections.fields.typeMetadata.datetime.maxDateFixed',
              },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'collection.fields.numberRange.min' },
              { path: 'collection.fields.numberRange.max' },
              { path: 'collection.fields.typeMetadata.number.defaultValue' },
              { path: 'collection.fields.typeMetadata.number.min' },
              { path: 'collection.fields.typeMetadata.number.max' },
              { path: 'referencedCollections.fields.numberRange.min' },
              { path: 'referencedCollections.fields.numberRange.max' },
              {
                path: 'referencedCollections.fields.typeMetadata.number.defaultValue',
              },
              { path: 'referencedCollections.fields.typeMetadata.number.min' },
              { path: 'referencedCollections.fields.typeMetadata.number.max' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __getDataCollection;
}

/**
 * Retrieves a list of all data collections associated with the site or project.
 *
 * By default, the list is ordered by ID in ascending order.
 */
export function listDataCollections(
  payload: object
): RequestOptionsFactory<any> {
  function __listDataCollections({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.data.v2.data_collection',
      method: 'GET' as any,
      methodFqn:
        'com.wixpress.cloud.data.api.collectionservice.DataCollectionService.ListDataCollections',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressCloudDataApiCollectionserviceDataCollectionServiceUrl(
        { protoPath: '/v2/collections', data: payload, host }
      ),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'collections.createdDate' },
              { path: 'collections.updatedDate' },
              {
                path: 'collections.fields.typeMetadata.date.defaultValueFixed',
              },
              { path: 'collections.fields.typeMetadata.date.minDateFixed' },
              { path: 'collections.fields.typeMetadata.date.maxDateFixed' },
              {
                path: 'collections.fields.typeMetadata.datetime.defaultValueFixed',
              },
              { path: 'collections.fields.typeMetadata.datetime.minDateFixed' },
              { path: 'collections.fields.typeMetadata.datetime.maxDateFixed' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'collections.fields.numberRange.min' },
              { path: 'collections.fields.numberRange.max' },
              { path: 'collections.fields.typeMetadata.number.defaultValue' },
              { path: 'collections.fields.typeMetadata.number.min' },
              { path: 'collections.fields.typeMetadata.number.max' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __listDataCollections;
}

/**
 * Updates a data collection.
 *
 * A collection ID, revision number, permissions, and at least 1 field must be provided in the `collection` body parameter.
 * If a collection with that ID exists, and if its current `revision` number matches the one provided, it's updated.
 * Otherwise, the request fails.
 *
 * <blockquote class="important">
 * <strong>Important:</strong>
 *
 * After a collection is updated, it only contains the properties included in the Update Data Collection request.
 * If the existing collection has properties with values and those properties aren't included in the updated collection details,
 * their values are lost.<br/><br/>
 *
 * To update only specific properties without affecting others, use [Patch Data Collection](https://dev.wix.com/docs/api-reference/business-solutions/cms/collection-management/data-collections/patch-data-collection).
 * </blockquote>
 *
 * When a collection is updated, its `updatedDate` changes to the current date and its `revision` increments by 1.
 *
 * To update only properties in a collection's `fields` array, use [Update Data Collection Field](https://dev.wix.com/docs/api-reference/business-solutions/cms/collection-management/data-collections/update-data-collection-field).
 * To only add or remove `plugins`, use [Add Data Collection Plugin](https://dev.wix.com/docs/api-reference/business-solutions/cms/collection-management/data-collections/add-data-collection-plugin) or [Delete Data Collection Plugin](https://dev.wix.com/docs/api-reference/business-solutions/cms/collection-management/data-collections/delete-data-collection-plugin).
 */
export function updateDataCollection(
  payload: object
): RequestOptionsFactory<any> {
  function __updateDataCollection({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: 'collection.createdDate' },
          { path: 'collection.updatedDate' },
          { path: 'collection.fields.typeMetadata.date.defaultValueFixed' },
          { path: 'collection.fields.typeMetadata.date.minDateFixed' },
          { path: 'collection.fields.typeMetadata.date.maxDateFixed' },
          { path: 'collection.fields.typeMetadata.datetime.defaultValueFixed' },
          { path: 'collection.fields.typeMetadata.datetime.minDateFixed' },
          { path: 'collection.fields.typeMetadata.datetime.maxDateFixed' },
        ],
      },
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: 'collection.fields.numberRange.min' },
          { path: 'collection.fields.numberRange.max' },
          { path: 'collection.fields.typeMetadata.number.defaultValue' },
          { path: 'collection.fields.typeMetadata.number.min' },
          { path: 'collection.fields.typeMetadata.number.max' },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.data.v2.data_collection',
      method: 'PUT' as any,
      methodFqn:
        'com.wixpress.cloud.data.api.collectionservice.DataCollectionService.UpdateDataCollection',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressCloudDataApiCollectionserviceDataCollectionServiceUrl(
        { protoPath: '/v2/collections', data: serializedData, host }
      ),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'collection.createdDate' },
              { path: 'collection.updatedDate' },
              { path: 'collection.fields.typeMetadata.date.defaultValueFixed' },
              { path: 'collection.fields.typeMetadata.date.minDateFixed' },
              { path: 'collection.fields.typeMetadata.date.maxDateFixed' },
              {
                path: 'collection.fields.typeMetadata.datetime.defaultValueFixed',
              },
              { path: 'collection.fields.typeMetadata.datetime.minDateFixed' },
              { path: 'collection.fields.typeMetadata.datetime.maxDateFixed' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'collection.fields.numberRange.min' },
              { path: 'collection.fields.numberRange.max' },
              { path: 'collection.fields.typeMetadata.number.defaultValue' },
              { path: 'collection.fields.typeMetadata.number.min' },
              { path: 'collection.fields.typeMetadata.number.max' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __updateDataCollection;
}

/**
 * Deletes a data collection.
 *
 * Before deleting a collection:
 * - Make sure the collection isn't connected to any site pages or elements.
 * - You can create a manual backup of a collections with the Backups API, in case you need to restore them later.
 * - You can also export a collection to a CSV file with the Data Movement Jobs API, if you want to save the data outside of Wix.
 *
 * > **Note:**
 * > Once a collection is deleted, it can only be restored for a limited amount of time.
 */
export function deleteDataCollection(
  payload: object
): RequestOptionsFactory<any> {
  function __deleteDataCollection({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.data.v2.data_collection',
      method: 'DELETE' as any,
      methodFqn:
        'com.wixpress.cloud.data.api.collectionservice.DataCollectionService.DeleteDataCollection',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressCloudDataApiCollectionserviceDataCollectionServiceUrl(
        { protoPath: '/v2/collections/{dataCollectionId}', data: payload, host }
      ),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __deleteDataCollection;
}

/**
 * Restores recently deleted collection.
 *
 * Fails with `WDE0025` if collection was deleted too long ago or has never existed.
 */
export function restoreDataCollection(
  payload: object
): RequestOptionsFactory<any> {
  function __restoreDataCollection({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.data.v2.data_collection',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.cloud.data.api.collectionservice.DataCollectionService.RestoreDataCollection',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressCloudDataApiCollectionserviceDataCollectionServiceUrl(
        {
          protoPath: '/v2/collections/restore/{dataCollectionId}',
          data: payload,
          host,
        }
      ),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'dataCollection.createdDate' },
              { path: 'dataCollection.updatedDate' },
              {
                path: 'dataCollection.fields.typeMetadata.date.defaultValueFixed',
              },
              { path: 'dataCollection.fields.typeMetadata.date.minDateFixed' },
              { path: 'dataCollection.fields.typeMetadata.date.maxDateFixed' },
              {
                path: 'dataCollection.fields.typeMetadata.datetime.defaultValueFixed',
              },
              {
                path: 'dataCollection.fields.typeMetadata.datetime.minDateFixed',
              },
              {
                path: 'dataCollection.fields.typeMetadata.datetime.maxDateFixed',
              },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'dataCollection.fields.numberRange.min' },
              { path: 'dataCollection.fields.numberRange.max' },
              {
                path: 'dataCollection.fields.typeMetadata.number.defaultValue',
              },
              { path: 'dataCollection.fields.typeMetadata.number.min' },
              { path: 'dataCollection.fields.typeMetadata.number.max' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __restoreDataCollection;
}

/**
 * Updates specified properties of a data collection.
 *
 * Only updates the properties specified in the request, all other properties remain unchanged.
 * The following properties can be updated with this method: `displayName`, `displayField`, `permissions`, `dataPermissions`. If attempting to update other, unsupported properties, this operation fails.
 *
 * To update properties in a collection's `fields`array, use [Patch Data Collection Field](https://dev.wix.com/docs/api-reference/business-solutions/cms/collection-management/data-collections/patch-data-collection-field).
 * To add or remove `plugins`, use [Add Data Collection Plugin](https://dev.wix.com/docs/api-reference/business-solutions/cms/collection-management/data-collections/add-data-collection-plugin) or [Delete Data Collection Plugin](https://dev.wix.com/docs/api-reference/business-solutions/cms/collection-management/data-collections/delete-data-collection-plugin).
 */
export function patchDataCollection(
  payload: object
): RequestOptionsFactory<any> {
  function __patchDataCollection({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFieldMaskToRESTFieldMask,
        paths: [{ path: 'fieldMask' }],
      },
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: 'dataCollection.createdDate' },
          { path: 'dataCollection.updatedDate' },
          { path: 'dataCollection.fields.typeMetadata.date.defaultValueFixed' },
          { path: 'dataCollection.fields.typeMetadata.date.minDateFixed' },
          { path: 'dataCollection.fields.typeMetadata.date.maxDateFixed' },
          {
            path: 'dataCollection.fields.typeMetadata.datetime.defaultValueFixed',
          },
          { path: 'dataCollection.fields.typeMetadata.datetime.minDateFixed' },
          { path: 'dataCollection.fields.typeMetadata.datetime.maxDateFixed' },
        ],
      },
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: 'dataCollection.fields.numberRange.min' },
          { path: 'dataCollection.fields.numberRange.max' },
          { path: 'dataCollection.fields.typeMetadata.number.defaultValue' },
          { path: 'dataCollection.fields.typeMetadata.number.min' },
          { path: 'dataCollection.fields.typeMetadata.number.max' },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.data.v2.data_collection',
      method: 'PATCH' as any,
      methodFqn:
        'com.wixpress.cloud.data.api.collectionservice.DataCollectionService.PatchDataCollection',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressCloudDataApiCollectionserviceDataCollectionServiceUrl(
        {
          protoPath: '/v2/collections/{dataCollection.id}',
          data: serializedData,
          host,
        }
      ),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'dataCollection.createdDate' },
              { path: 'dataCollection.updatedDate' },
              {
                path: 'dataCollection.fields.typeMetadata.date.defaultValueFixed',
              },
              { path: 'dataCollection.fields.typeMetadata.date.minDateFixed' },
              { path: 'dataCollection.fields.typeMetadata.date.maxDateFixed' },
              {
                path: 'dataCollection.fields.typeMetadata.datetime.defaultValueFixed',
              },
              {
                path: 'dataCollection.fields.typeMetadata.datetime.minDateFixed',
              },
              {
                path: 'dataCollection.fields.typeMetadata.datetime.maxDateFixed',
              },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'dataCollection.fields.numberRange.min' },
              { path: 'dataCollection.fields.numberRange.max' },
              {
                path: 'dataCollection.fields.typeMetadata.number.defaultValue',
              },
              { path: 'dataCollection.fields.typeMetadata.number.min' },
              { path: 'dataCollection.fields.typeMetadata.number.max' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __patchDataCollection;
}

/** Adds a new field to the structure of a data collection. */
export function createDataCollectionField(
  payload: object
): RequestOptionsFactory<any> {
  function __createDataCollectionField({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: 'field.numberRange.min' },
          { path: 'field.numberRange.max' },
          { path: 'field.typeMetadata.number.defaultValue' },
          { path: 'field.typeMetadata.number.min' },
          { path: 'field.typeMetadata.number.max' },
        ],
      },
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: 'field.typeMetadata.date.defaultValueFixed' },
          { path: 'field.typeMetadata.date.minDateFixed' },
          { path: 'field.typeMetadata.date.maxDateFixed' },
          { path: 'field.typeMetadata.datetime.defaultValueFixed' },
          { path: 'field.typeMetadata.datetime.minDateFixed' },
          { path: 'field.typeMetadata.datetime.maxDateFixed' },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.data.v2.data_collection',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.cloud.data.api.collectionservice.DataCollectionService.CreateDataCollectionField',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressCloudDataApiCollectionserviceDataCollectionServiceUrl(
        {
          protoPath: '/v2/collections/create-field',
          data: serializedData,
          host,
        }
      ),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'dataCollection.createdDate' },
              { path: 'dataCollection.updatedDate' },
              {
                path: 'dataCollection.fields.typeMetadata.date.defaultValueFixed',
              },
              { path: 'dataCollection.fields.typeMetadata.date.minDateFixed' },
              { path: 'dataCollection.fields.typeMetadata.date.maxDateFixed' },
              {
                path: 'dataCollection.fields.typeMetadata.datetime.defaultValueFixed',
              },
              {
                path: 'dataCollection.fields.typeMetadata.datetime.minDateFixed',
              },
              {
                path: 'dataCollection.fields.typeMetadata.datetime.maxDateFixed',
              },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'dataCollection.fields.numberRange.min' },
              { path: 'dataCollection.fields.numberRange.max' },
              {
                path: 'dataCollection.fields.typeMetadata.number.defaultValue',
              },
              { path: 'dataCollection.fields.typeMetadata.number.min' },
              { path: 'dataCollection.fields.typeMetadata.number.max' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __createDataCollectionField;
}

/**
 * Updates properties in a [data collection's](https://dev.wix.com/docs/api-reference/business-solutions/cms/collection-management/data-collections/create-data-collection) `fields` array.
 *
 * <blockquote class="important">
 * <strong>Important:</strong>
 *
 * After `fields` is updated, it only contains the properties included in the Update Data Collection Field request.
 * If the existing `fields` array has properties with values and those properties aren't included in the updated details, their values are lost.<br/><br/>
 *
 * To update only specific properties in the array without affecting others, use [Patch Data Collection Field](https://dev.wix.com/docs/api-reference/business-solutions/cms/collection-management/data-collections/patch-data-collection-field).
 * </blockquote>
 */
export function updateDataCollectionField(
  payload: object
): RequestOptionsFactory<any> {
  function __updateDataCollectionField({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: 'field.numberRange.min' },
          { path: 'field.numberRange.max' },
          { path: 'field.typeMetadata.number.defaultValue' },
          { path: 'field.typeMetadata.number.min' },
          { path: 'field.typeMetadata.number.max' },
        ],
      },
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: 'field.typeMetadata.date.defaultValueFixed' },
          { path: 'field.typeMetadata.date.minDateFixed' },
          { path: 'field.typeMetadata.date.maxDateFixed' },
          { path: 'field.typeMetadata.datetime.defaultValueFixed' },
          { path: 'field.typeMetadata.datetime.minDateFixed' },
          { path: 'field.typeMetadata.datetime.maxDateFixed' },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.data.v2.data_collection',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.cloud.data.api.collectionservice.DataCollectionService.UpdateDataCollectionField',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressCloudDataApiCollectionserviceDataCollectionServiceUrl(
        {
          protoPath: '/v2/collections/update-field',
          data: serializedData,
          host,
        }
      ),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'dataCollection.createdDate' },
              { path: 'dataCollection.updatedDate' },
              {
                path: 'dataCollection.fields.typeMetadata.date.defaultValueFixed',
              },
              { path: 'dataCollection.fields.typeMetadata.date.minDateFixed' },
              { path: 'dataCollection.fields.typeMetadata.date.maxDateFixed' },
              {
                path: 'dataCollection.fields.typeMetadata.datetime.defaultValueFixed',
              },
              {
                path: 'dataCollection.fields.typeMetadata.datetime.minDateFixed',
              },
              {
                path: 'dataCollection.fields.typeMetadata.datetime.maxDateFixed',
              },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'dataCollection.fields.numberRange.min' },
              { path: 'dataCollection.fields.numberRange.max' },
              {
                path: 'dataCollection.fields.typeMetadata.number.defaultValue',
              },
              { path: 'dataCollection.fields.typeMetadata.number.min' },
              { path: 'dataCollection.fields.typeMetadata.number.max' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __updateDataCollectionField;
}

/**
 * Deletes a field from the structure of a data collection.
 *
 * When a field is deleted, all values associated with that field are also deleted
 * from all items in the collection.
 */
export function deleteDataCollectionField(
  payload: object
): RequestOptionsFactory<any> {
  function __deleteDataCollectionField({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.data.v2.data_collection',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.cloud.data.api.collectionservice.DataCollectionService.DeleteDataCollectionField',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressCloudDataApiCollectionserviceDataCollectionServiceUrl(
        { protoPath: '/v2/collections/delete-field', data: payload, host }
      ),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'dataCollection.createdDate' },
              { path: 'dataCollection.updatedDate' },
              {
                path: 'dataCollection.fields.typeMetadata.date.defaultValueFixed',
              },
              { path: 'dataCollection.fields.typeMetadata.date.minDateFixed' },
              { path: 'dataCollection.fields.typeMetadata.date.maxDateFixed' },
              {
                path: 'dataCollection.fields.typeMetadata.datetime.defaultValueFixed',
              },
              {
                path: 'dataCollection.fields.typeMetadata.datetime.minDateFixed',
              },
              {
                path: 'dataCollection.fields.typeMetadata.datetime.maxDateFixed',
              },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'dataCollection.fields.numberRange.min' },
              { path: 'dataCollection.fields.numberRange.max' },
              {
                path: 'dataCollection.fields.typeMetadata.number.defaultValue',
              },
              { path: 'dataCollection.fields.typeMetadata.number.min' },
              { path: 'dataCollection.fields.typeMetadata.number.max' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __deleteDataCollectionField;
}

/**
 * Adds a plugin to a data collection.
 *
 * If a plugin of the same type already exists in the collection, this operation fails.
 */
export function addDataCollectionPlugin(
  payload: object
): RequestOptionsFactory<any> {
  function __addDataCollectionPlugin({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.data.v2.data_collection',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.cloud.data.api.collectionservice.DataCollectionService.AddDataCollectionPlugin',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressCloudDataApiCollectionserviceDataCollectionServiceUrl(
        { protoPath: '/v2/collections/add-plugin', data: payload, host }
      ),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'dataCollection.createdDate' },
              { path: 'dataCollection.updatedDate' },
              {
                path: 'dataCollection.fields.typeMetadata.date.defaultValueFixed',
              },
              { path: 'dataCollection.fields.typeMetadata.date.minDateFixed' },
              { path: 'dataCollection.fields.typeMetadata.date.maxDateFixed' },
              {
                path: 'dataCollection.fields.typeMetadata.datetime.defaultValueFixed',
              },
              {
                path: 'dataCollection.fields.typeMetadata.datetime.minDateFixed',
              },
              {
                path: 'dataCollection.fields.typeMetadata.datetime.maxDateFixed',
              },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'dataCollection.fields.numberRange.min' },
              { path: 'dataCollection.fields.numberRange.max' },
              {
                path: 'dataCollection.fields.typeMetadata.number.defaultValue',
              },
              { path: 'dataCollection.fields.typeMetadata.number.min' },
              { path: 'dataCollection.fields.typeMetadata.number.max' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __addDataCollectionPlugin;
}

/**
 * Removes a plugin from a data collection.
 *
 * Removing a plugin disables its functionality for the collection.
 */
export function deleteDataCollectionPlugin(
  payload: object
): RequestOptionsFactory<any> {
  function __deleteDataCollectionPlugin({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.data.v2.data_collection',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.cloud.data.api.collectionservice.DataCollectionService.DeleteDataCollectionPlugin',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressCloudDataApiCollectionserviceDataCollectionServiceUrl(
        { protoPath: '/v2/collections/delete-plugin', data: payload, host }
      ),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'dataCollection.createdDate' },
              { path: 'dataCollection.updatedDate' },
              {
                path: 'dataCollection.fields.typeMetadata.date.defaultValueFixed',
              },
              { path: 'dataCollection.fields.typeMetadata.date.minDateFixed' },
              { path: 'dataCollection.fields.typeMetadata.date.maxDateFixed' },
              {
                path: 'dataCollection.fields.typeMetadata.datetime.defaultValueFixed',
              },
              {
                path: 'dataCollection.fields.typeMetadata.datetime.minDateFixed',
              },
              {
                path: 'dataCollection.fields.typeMetadata.datetime.maxDateFixed',
              },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'dataCollection.fields.numberRange.min' },
              { path: 'dataCollection.fields.numberRange.max' },
              {
                path: 'dataCollection.fields.typeMetadata.number.defaultValue',
              },
              { path: 'dataCollection.fields.typeMetadata.number.min' },
              { path: 'dataCollection.fields.typeMetadata.number.max' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __deleteDataCollectionPlugin;
}

/**
 * Updates specified properties in a [data collection's](https://dev.wix.com/docs/api-reference/business-solutions/cms/collection-management/data-collections/create-data-collection) `fields` array.
 *
 * Only updates the properties specified in the request, all other properties remain unchanged.
 * The following properties can be updated with this method: `displayName`, `type`, `typeMetadata`, `encrypted`, `description`. If attempting to update `key` or other unsupported properties, this operation fails.
 *
 * To update properties in a data collection other than `fields`, use [Patch Data Collection](https://dev.wix.com/docs/api-reference/business-solutions/cms/collection-management/data-collections/patch-data-collection).
 */
export function patchDataCollectionField(
  payload: object
): RequestOptionsFactory<any> {
  function __patchDataCollectionField({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFieldMaskToRESTFieldMask,
        paths: [{ path: 'fieldMask' }],
      },
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: 'field.numberRange.min' },
          { path: 'field.numberRange.max' },
          { path: 'field.typeMetadata.number.defaultValue' },
          { path: 'field.typeMetadata.number.min' },
          { path: 'field.typeMetadata.number.max' },
        ],
      },
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: 'field.typeMetadata.date.defaultValueFixed' },
          { path: 'field.typeMetadata.date.minDateFixed' },
          { path: 'field.typeMetadata.date.maxDateFixed' },
          { path: 'field.typeMetadata.datetime.defaultValueFixed' },
          { path: 'field.typeMetadata.datetime.minDateFixed' },
          { path: 'field.typeMetadata.datetime.maxDateFixed' },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.data.v2.data_collection',
      method: 'PATCH' as any,
      methodFqn:
        'com.wixpress.cloud.data.api.collectionservice.DataCollectionService.PatchDataCollectionField',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressCloudDataApiCollectionserviceDataCollectionServiceUrl(
        {
          protoPath: '/v2/collections/{dataCollectionId}/patch-field',
          data: serializedData,
          host,
        }
      ),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'dataCollection.createdDate' },
              { path: 'dataCollection.updatedDate' },
              {
                path: 'dataCollection.fields.typeMetadata.date.defaultValueFixed',
              },
              { path: 'dataCollection.fields.typeMetadata.date.minDateFixed' },
              { path: 'dataCollection.fields.typeMetadata.date.maxDateFixed' },
              {
                path: 'dataCollection.fields.typeMetadata.datetime.defaultValueFixed',
              },
              {
                path: 'dataCollection.fields.typeMetadata.datetime.minDateFixed',
              },
              {
                path: 'dataCollection.fields.typeMetadata.datetime.maxDateFixed',
              },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'dataCollection.fields.numberRange.min' },
              { path: 'dataCollection.fields.numberRange.max' },
              {
                path: 'dataCollection.fields.typeMetadata.number.defaultValue',
              },
              { path: 'dataCollection.fields.typeMetadata.number.min' },
              { path: 'dataCollection.fields.typeMetadata.number.max' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __patchDataCollectionField;
}
